import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import InsuranceForm from "../form/insuranceForm";
import useInsuranceModal from "../hooks/useInsuranceModal";

const InsuranceModal = () => {
  const { showInsuranceModal, isUpdateOperation, handleModalClose } =
    useInsuranceModal();

  return (
    <ModalWrapper
      show={showInsuranceModal}
      onClose={handleModalClose}
      fullWidth
      title={<span>{isUpdateOperation ? "Update" : "Add"} Insurance</span>}
    >
      <InsuranceForm />
    </ModalWrapper>
  );
};

export default InsuranceModal;
